import type { RouteRecordRaw } from 'vue-router';

const onboardingRoutes: RouteRecordRaw = {
  path: '/onboarding',
  name: 'onboarding',
  meta: { auth: true },
  component: () => import('@/views/pages/onboarding/OnboardingWizard.vue'),
};

export default onboardingRoutes;
